import type { RGB } from '@/app/utils';

export const HSLToRGBA = (h: number, s: number, l: number, a: number) => {
  // IMPORTANT if s and l between 0,1 remove the next two lines:
  s /= 100;
  l /= 100;

  const k = (n: number) => (n + h / 30) % 12;
  const b = s * Math.min(l, 1 - l);
  const f = (n: number) =>
    l - b * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

  return {
    r: Math.round(255 * f(0)),
    g: Math.round(255 * f(8)),
    b: Math.round(255 * f(4)),
    a: a,
  };
};

export const hexToRgba = (hex: string, alpha?: number) => {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    let c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const colorNumber = Number('0x' + c.join(''));
    return {
      r: (colorNumber >> 16) & 255,
      g: (colorNumber >> 8) & 255,
      b: colorNumber & 255,
      a: alpha ? alpha : 140,
    };
  }
  throw new Error('Bad Hex');
};

export const convertColorArrayToString = (s: RGB, alpha: number = 1) =>
  `rgba(${s[0]},${s[1]},${s[2]},${alpha})`;
